import gql from 'graphql-tag';

export default gql`
  query vendorLayerAggregationQuery(
    $fields: [String!]
    $filter: VendorLayerCollectionFilters
  ) {
    vendorLayerAggregation(fields: $fields, filter: $filter) {
      field
      counts {
        key
        totals
      }
    }
  }
`;
